export default "__VITE_ASSET__C79J98B6__"